import { h } from 'preact';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';
import { Switch, SwitchProps, useLocation } from 'wouter-preact';

export default function AnimatedRouter({ children, classNames, timeout }: Pick<CSSTransitionProps, 'classNames' | 'timeout'> & Pick<SwitchProps, 'children'>) {
    const [location] = useLocation();

    return (
        <TransitionGroup component="div" class="switcher">
            <CSSTransition key={location} classNames={classNames} timeout={timeout}>
                <Switch children={children} location={location} />
            </CSSTransition>
        </TransitionGroup>
    );
}
